import { render, staticRenderFns } from "./UsersData.vue?vue&type=template&id=72aa1b72&"
import script from "./UsersData.vue?vue&type=script&lang=js&"
export * from "./UsersData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports